import type { CommonTranslations } from '../../types';

export const frCommon: CommonTranslations = {
  nav: {
    home: 'Accueil',
    products: 'Produits',
    technology: 'Technologie',
    about: '\u00C0 propos',
    contact: 'Contact',
    faq: 'FAQ',
  },
  footer: {
    contact: 'Contactez-nous',
    phone: 'T\u00E9l\u00E9phone',
    email: 'E-mail',
    address: 'Adresse',
    rights: 'Tous droits r\u00E9serv\u00E9s.',
    brandDesc: 'Fabricant sp\u00E9cialis\u00E9 de radiateurs \u00E0 infrarouges. Apportant chaleur, confort et efficacit\u00E9 \u00E9nerg\u00E9tique au monde depuis 2006.',
    products: 'Produits',
    support: 'Support',
    newsletter: 'Restez inform\u00E9',
    newsletterDesc: 'Abonnez-vous pour recevoir les derni\u00E8res mises \u00E0 jour des produits et actualit\u00E9s du secteur.',
    join: 'Rejoindre',
    catalog: 'T\u00E9l\u00E9charger le catalogue',
    emailPlaceholder: 'Entrez votre e-mail',
    product1: 'Radiateur infrarouge',
    product2: 'Radiateur portable',
    product3: '',
    product4: '',
    privacy: 'Politique de confidentialit\u00E9',
    terms: 'Conditions d\'utilisation',
    sitemap: 'Plan du site',
    installationGuide: "Guide d'installation",
    warrantyPolicy: 'Politique de garantie',
  },
};
